import i18next from "i18next";
import * as yup from "yup";

export default function validation() {
  return yup.object().shape({
    name: yup
      .string()
      .required(
        i18next.t("validation.adminManageSubscription.subscriptionName")
      )
      .matches(/^[^\s].+[^\s]$/g, i18next.t("validation.common.noSpace"))
      .min(3, "Minimum 3 Character required")
      .trim(i18next.t("validation.common.noSpace")),
    amount: yup
      .number("Amount must be a number")
      .positive("Amount must be a positive value")
      .required(
        i18next.t("validation.adminManageSubscription.subscriptionAmount")
      ),
  });
}
